import { Tag, Typography } from 'antd'
import { isValidArray } from '../../../../sprints/components/testReport/testCases/forms/helper'

const { Text } = Typography

const ShowFilter = ({ data, onRemove }) => {
    // Format values for each key
    const formatValue = (key, value) => {
        if (!value) return 'N/A'

        if (Array.isArray(value)) {
            // Array of objects → join titles/names/labels
            if (value.length === 0) return 'N/A'
            return value.map((v) => v.label || v.title || v.name).join(', ')
        }

        if (typeof value === 'object') {
            return value.label || value.title || value.name || 'N/A'
        }

        return value // primitive string/number
    }

    const renderTag = (key, label, color, value) => (
        <Tag
            key={key}
            color={color}
            closable={!!onRemove}
            onClose={(e) => {
                e.preventDefault()
                onRemove?.(key)
            }}
        >
            <Text type="secondary" style={{ fontSize: '11px' }}>
                {label}:
            </Text>{' '}
            <Text strong style={{ fontSize: '11px' }}>
                {formatValue(key, value)}
            </Text>
        </Tag>
    )

    return (
        <>
            {isValidArray(data?.epic) &&
                renderTag('epic', 'Epic', 'blue', data?.epic)}

            {data?.sprint &&
                renderTag('sprint', 'Sprint', 'geekblue', data?.sprint)}

            {isValidArray(data?.tags) &&
                renderTag('tags', 'Tags', 'green', data?.tags)}

            {(data?.search?.title || data?.search?.testId) &&
                renderTag(
                    'search',
                    'Search',
                    'geekblue',
                    data?.search?.title || data?.search?.testId
                )}

            {data?.project &&
                renderTag('project', 'Project', 'purple', data?.project)}
        </>
    )
}

export default ShowFilter
